<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col sm="12" lg="12" v-if="tagsOptions.length > 0 && !isWholesaler && !isSalesRepresentative">
        <b-form-group>
          <label>{{$t("views.exsborder.list.tags")}}: </label>
          <multi-select :options="tagsOptions" :selected-options="item.userDataTags" @select="onSelectTags" >
          </multi-select>
        </b-form-group>
      </b-col>
      <b-col v-if="!isWholesaler">
        <div :class="['form-group', isInvalid('idStatus') ? 'has-danger' : '']">
          <label
                  for="userdata_idStatus"
                  class="form-control-label">{{$t('views.firm.form.idStatus')}}:</label>
          <model-select :options="statusOptions" v-model="item.status"></model-select>
        </div>
      </b-col>
      <b-col v-if="!isWholesaler">
        <div :class="['form-group', isInvalid('idOpportunity') ? 'has-danger' : '']">
          <label
                  for="userdata_idOpportunity"
                  class="form-control-label">{{$t('views.firm.form.idOpportunity')}}:</label>
          <model-select :options="salesOpportunitiesOptions" v-model="item.salesOpportunity"></model-select>
        </div>
      </b-col>
      <b-col v-if="!isWholesaler">
        <div :class="['form-group', isInvalid('workplace') ? 'has-danger' : '']">
          <label
            for="userdata_idWorkplace"
            class="form-control-label">{{$t('views.firm.form.idWorkplace')}}:</label>
          <model-select :options="workplacesOptions" v-model="item.workplace"></model-select>
        </div>
      </b-col>
      <b-col v-if="!isWholesaler">
        <div class="form-group">
          <label
            for="userdata_salesRepresentative"
            class="form-control-label">{{ $t('views.userdata.form.idSalesRepresentative') }}:</label>
          <base-select-input
            v-model="item.idSalesRepresentative"
            :search-callback="getSalesRepresentativesCallback"
            :display-values="['fullName']"
            :query-param="'userdata'"
            :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></base-select-input>
        </div>
      </b-col>
    </b-row>
<!--    IMIĘ I NAZWISKO START-->
    <b-row>
      <b-col cols="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_name"
            class="form-control-label">{{ $t('views.userdata.form.name') }}:</label>
          <b-row>
            <b-col class="pr-0">
              <input
                id="userdata_name"
                v-model="item.name"
                :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                type="text"
                placeholder=""
                @input="handleUpdateField('name', $event.target.value)">
            </b-col>
          </b-row>
          <div
            v-if="isInvalid('name')"
            class="invalid-feedback">{{ violations.name }}</div>
        </div>
      </b-col>
      <b-col cols="10" lg="4">
        <div class="form-group">
          <label
            for="userdata_surname"
            class="form-control-label">{{ $t('views.userdata.form.surname') }}:</label>
          <b-row>
            <b-col class="pr-0">
              <input
                id="userdata_surname"
                v-model="item.surname"
                :class="['form-control', isInvalid('surname') ? 'is-invalid' : '']"
                type="text"
                placeholder=""
                @input="handleUpdateField('surname', $event.target.value)">
            </b-col>
          </b-row>
          <div
            v-if="isInvalid('surname')"
            class="invalid-feedback">{{ violations.surname }}</div>
        </div>
      </b-col>
      <b-col cols="2" lg="4">
          <label
            for="is_company"
            class="form-control-label">{{$t('views.firm.form.isCompany')}}:</label>
          <b-form-group>
            <b-form-radio-group buttons id="is_company" button-variant="outline-primary" v-model="item.isCompany" name="isCompany"
                                :aria-expanded="true"
                                aria-controls="collapse-1">
              <b-form-radio size="sm" :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
              <b-form-radio size="sm" :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
      </b-col>
    </b-row>
<!--    IMIĘ I NAZWISKO KONIEC-->
<!--    EMAIL I ADRES-->
    <b-row>
      <b-col sm="12" lg="4">
        <b-form-group>
          <label for="userdata_email" class="form-control-label">
            {{ $t('views.userdata.form.userEmail') }}:
          </label>
            <input
              id="userdata_email"
              v-model="item.userEmail"
              :class="['form-control', isInvalid('userEmail') ? 'is-invalid' : '']"
              type="email"
              @input="handleUpdateField('userEmail', $event.target.value)">
          <div
            v-if="isInvalid('userEmail')"
            class="invalid-feedback">{{ violations.userEmail }}
          </div>
        </b-form-group>
      </b-col>
      <b-col sm="12" lg="4">
        <b-form-group>
          <label for="userdata_phone" class="form-control-label">
            {{ $t('views.userdata.form.mobilePhone') }}:
          </label>
          <input
            id="userdata_mobile_phone"
            v-model="item.mobilePhone"
            :class="['form-control', isInvalid('mobilePhone') ? 'is-invalid' : '']"
            type="mobilePhone"
            @input="handleUpdateField('mobilePhone', $event.target.value)">
          <div
            v-if="isInvalid('mobilePhone')"
            class="invalid-feedback">{{ violations.mobilePhone }}
          </div>
        </b-form-group>
      </b-col>
      <b-col sm="12" lg="4">
        <b-form-group>
          <label for="userdata_phone" class="form-control-label">
            {{ $t('views.userdata.form.phone') }}:
          </label>
          <input
            id="userdata_phone"
            v-model="item.phone"
            :class="['form-control', isInvalid('phone') ? 'is-invalid' : '']"
            type="mobilePhone"
            @input="handleUpdateField('phone', $event.target.value)">
          <div
            v-if="isInvalid('phone')"
            class="invalid-feedback">{{ violations.phone }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
<!--    FIRMA START-->
    <b-collapse id="collapse-4" v-model="isCompanyBool">
      <b-row>
        <b-col cols="12" lg="4" v-if="!isWholesaler">
          <div :class="['form-group', isInvalid('idClientType') ? 'has-danger' : '']">
            <label
              for="userdata_idClientType"
              class="form-control-label">{{$t('views.firm.form.idClientType')}}:</label>
            <fg-input :error="violations.idClientType">
              <el-select
                id="userdata_idClientType"
                :class="['select-default', isInvalid('idClientType') ? 'select-danger' : '']"
                filterable
                remote
                reserve-keyword
                v-model="item.idClientType">
                <el-option v-for="option in firmClientTypes"
                           class="select-default"
                           :value="option.value"
                           :label="option.text"
                           :key="option.value">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="4" v-if="!isWholesaler">
          <div :class="['form-group', isInvalid('isHeadquarters') ? 'has-danger' : '']">
            <label
              for="userdata_isHeadquarters"
              class="form-control-label">{{$t('views.firm.form.isHeadquarters')}}:</label>
            <fg-input :error="violations.isHeadquarters">
              <el-select
                id="userdata_isHeadquarters"
                :class="['select-default', isInvalid('isHeadquarters') ? 'select-danger' : '']"
                filterable
                remote
                reserve-keyword
                v-model="item.isHeadquarters">
                <el-option v-for="option in firmTypes"
                           class="select-default"
                           :value="option.value"
                           :label="option.text"
                           :key="option.value">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="4" v-if="item.isHeadquarters === 0">
          <div :class="['form-group', isInvalid('idHeadquarters') ? 'has-danger' : '']">
            <label
              for="userdata_idHeadquarters"
              class="form-control-label">{{$t('views.firm.form.idHeadquarters')}}:</label>
            <fg-input :error="violations.idHeadquarters">
              <el-select
                id="userdata_idHeadquarters"
                :class="['select-default', isInvalid('idHeadquarters') ? 'select-danger' : '']"
                filterable
                remote
                reserve-keyword
                v-model="item.idHeadquarters">
                <el-option v-for="option in headquartersOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.firmname1"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label
                    for="userdata_nip"
                    class="form-control-label">{{ $t('views.firm.form.nip') }}:</label>
            <b-row>
              <b-col class="pr-0">
                <input
                        id="userdata_nip"
                        v-model="item.nip"
                        :class="['form-control', isInvalid('nip') ? 'is-invalid' : '']"
                        type="text"
                        placeholder=""
                        @input="handleUpdateField('nip', $event.target.value)">
              </b-col>
              <b-col cols="4" class="pl-0">
                <b-button class="btn btn-primary mb-0 mt-0 w-100 pl-1 pr-1"
                          @click="getFirmDataByNip(item.nip)"
                          v-b-tooltip.hover :title="$t('views.firm.form.downloadDataTooltip')">{{$t('views.firm.form.downloadData')}}</b-button>
              </b-col>
            </b-row>
            <div
                    v-if="isInvalid('nip')"
                    class="invalid-feedback">{{ violations.nip }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label
                    for="userdata_firmname1"
                    class="form-control-label">{{ $t('views.firm.form.firmname1') }}:</label>
            <input
                    id="userdata_firmname1"
                    v-model="item.firmname1"
                    :class="['form-control', isInvalid('firmname1') ? 'is-invalid' : '']"
                    type="text"
                    placeholder=""
                    @input="handleUpdateField('firmname1', $event.target.value)">
            <div
                    v-if="isInvalid('firmname1')"
                    class="invalid-feedback">{{ violations.firmname1 }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="4" v-if="!isWholesaler">
          <div class="form-group">
            <label
                    for="userdata_firmname2"
                    class="form-control-label">{{ $t('views.firm.form.firmname2') }}:</label>
            <input
                    id="userdata_firmname2"
                    v-model="item.firmname2"
                    :class="['form-control', isInvalid('firmname2') ? 'is-invalid' : '']"
                    type="text"
                    placeholder=""
                    @input="handleUpdateField('firmname2', $event.target.value)">
            <div
                    v-if="isInvalid('firmname2')"
                    class="invalid-feedback">{{ violations.firmname2 }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label
              for="userdata_regon"
              class="form-control-label">{{ $t('views.firm.form.regon') }}:</label>
            <input
              id="userdata_regon"
              v-model="item.regon"
              :class="['form-control', isInvalid('regon') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('regon', $event.target.value)">
            <div
              v-if="isInvalid('regon')"
              class="invalid-feedback">{{ violations.regon }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="4">
          <div class="form-group">
            <label
              for="userdata_krs"
              class="form-control-label">{{ $t('views.firm.form.krs') }}:</label>
            <input
              id="userdata_krs"
              v-model="item.krs"
              :class="['form-control', isInvalid('krs') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('krs', $event.target.value)">
            <div
              v-if="isInvalid('krs')"
              class="invalid-feedback">{{ violations.krs }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="2" v-if="!isWholesaler">
          <div :class="['form-group', isInvalid('idRegion') ? 'has-danger' : '']">
            <label
              for="userdata_idRegion"
              class="form-control-label">{{$t('views.firm.form.idRegion')}}:</label>
            <fg-input :error="violations.idRegion">
              <el-select
                id="userdata_idRegion"
                :class="['select-default', isInvalid('idRegion') ? 'select-danger' : '']"
                filterable
                remote
                reserve-keyword
                v-model="item.idRegion">
                <el-option v-for="option in regionsOptions"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.title"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
        <b-col cols="12" lg="2" v-if="!isWholesaler">
          <div :class="['form-group', isInvalid('customSymbol') ? 'has-danger' : '']">
            <label
              for="userdata_customSymbol"
              class="form-control-label">{{$t('views.firm.form.customSymbol')}}:</label>
            <input
              id="userdata_customSymbol"
              v-model="item.customSymbol"
              :class="['form-control', isInvalid('customSymbol') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('customSymbol', $event.target.value)">
            <div
              v-if="isInvalid('customSymbol')"
              class="invalid-feedback">{{ violations.customSymbol }}</div>
          </div>
        </b-col>
        <b-col cols="12" lg="4" v-if="!isWholesaler">
          <div :class="['form-group', isInvalid('maxOpenCasesForPartnerAllowed') ? 'has-danger' : '']">
            <label
              for="userdata_customSymbol"
              class="form-control-label">{{$t('views.firm.form.maxOpenCasesForPartnerAllowed')}}:</label>
            <input
              id="userdata_maxOpenCasesForPartnerAllowed"
              v-model="item.maxOpenCasesForPartnerAllowed"
              :class="['form-control', isInvalid('maxOpenCasesForPartnerAllowed') ? 'is-invalid' : '']"
              type="text"
              placeholder=""
              @input="handleUpdateField('maxOpenCasesForPartnerAllowed', $event.target.value)">
            <div
              v-if="isInvalid('maxOpenCasesForPartnerAllowed')"
              class="invalid-feedback">{{ violations.maxOpenCasesForPartnerAllowed }}</div>
          </div>
        </b-col>
      </b-row>
    </b-collapse>
<!--      FIRMA KONIEC-->
    <hr class="my-1">
<!--    ADRESY-->
    <b-row>
<!--      ADRES GŁÓWNY-->
      <b-col>
        <b-row>
          <b-col sm="12" lg="2" class="align-self-center text-center">
            <h6>
              {{ $t('views.userdataaddress.form.addressType0') }}
            </h6>
          </b-col>
          <b-col sm="12" lg="10">
            <b-row>
              <b-col sm="12" lg="5">
                <div class="form-group">
                  <label
                    for="userdata_street"
                    class="form-control-label">{{ $t('views.firm.form.street') }}:</label>
                  <input
                    id="userdata_street"
                    v-model="item.street"
                    :class="['form-control', isInvalid('street') ? 'is-invalid' : '']"
                    type="text"
                    placeholder=""
                    @input="handleUpdateField('street', $event.target.value)">
                  <div
                    v-if="isInvalid('street')"
                    class="invalid-feedback">{{ violations.street }}</div>
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="form-group">
                  <label
                    for="userdata_street"
                    class="form-control-label">{{ $t('views.userdata.form.streetNumber') }}:</label>
                  <input
                    id="user_data_street_number"
                    v-model="item.streetNumber"
                    :class="['form-control', isInvalid('streetNumber') ? 'is-invalid' : '']"
                    type="text"
                    placeholder=""
                    @input="handleUpdateField('streetNumber', $event.target.value)">
                  <div
                    v-if="isInvalid('streetNumber')"
                    class="invalid-feedback">{{ violations.streetNumber }}</div>
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="form-group">
                  <label
                    for="userdata_street"
                    class="form-control-label">{{ $t('views.userdata.form.placeNumber') }}:</label>
                  <input
                    id="user_data_local_number"
                    v-model="item.placeNumber"
                    :class="['form-control', isInvalid('placeNumber') ? 'is-invalid' : '']"
                    type="text"
                    placeholder=""
                    @input="handleUpdateField('placeNumber', $event.target.value)">
                  <div
                    v-if="isInvalid('placeNumber')"
                    class="invalid-feedback">{{ violations.placeNumber }}</div>
                </div>
              </b-col>
              <b-col sm="12" lg="4">
                <div class="form-group">
                  <label
                    for="userdata_city"
                    class="form-control-label">{{ $t('views.firm.form.city') }}:</label>
                  <input
                    id="userdata_city"
                    v-model="item.city"
                    :class="['form-control', isInvalid('city') ? 'is-invalid' : '']"
                    type="text"
                    placeholder=""
                    @input="handleUpdateField('city', $event.target.value)">
                  <div
                    v-if="isInvalid('city')"
                    class="invalid-feedback">{{ violations.city }}</div>
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="form-group">
                  <label
                    for="userdata_postcode"
                    class="form-control-label">{{ $t('views.firm.form.postcode') }}:</label>
                  <input
                    id="userdata_postcode"
                    v-model="item.postcode"
                    :class="['form-control', isInvalid('postcode') ? 'is-invalid' : '']"
                    type="text"
                    placeholder=""
                    pattern="[0-9][0-9]-[0-9][0-9][0-9]"
                    @input="handleUpdateField('postcode', $event.target.value)">
                  <div
                    v-if="isInvalid('postcode')"
                    class="invalid-feedback">{{ violations.postcode }}</div>
                </div>
              </b-col>
              <b-col sm="12" lg="4">
                <b-form-group>
                  <label
                    for="userdata_province"
                    class="form-control-label">{{ $t('views.firm.form.province') }}:</label>
                  <model-select :options="provinceOptions" v-model="item.province"></model-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
  <!--      ADRESY DODATKOWE-->
        <b-row v-for="(address, addressIndex) in item.userDataAddresses" :key="'address_' + addressIndex">
          <b-col cols="12">
            <hr class="my-1">
          </b-col>
          <b-col sm="12" lg="2" >
            <b-form-group>
              <label
                :for="'userdata_address_type_'+addressIndex"
                class="form-control-label">{{$t('views.userdata.form.addressType')}}:</label>
                <el-select
                  :id="'userdata_address_type_'+addressIndex"
                  class="select-default"
                  filterable
                  v-model="item.userDataAddresses[addressIndex].addressType">
                  <el-option v-for="option in addressTypeOptions"
                             class="select-default"
                             :value="option.value"
                             :label="option.text"
                             :key="option.value">
                  </el-option>
                </el-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="9">
            <b-row>
              <b-col sm="12" lg="6">
                <div class="form-group">
                  <label
                    :for="'userdata_street_'+addressIndex"
                    class="form-control-label">{{ $t('views.firm.form.street') }}:</label>
                  <input
                    :id="'userdata_street_'+addressIndex"
                    v-model="item.userDataAddresses[addressIndex].street"
                    class="form-control"
                    type="text">
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="form-group">
                  <label
                    :for="'userdata_street_'+addressIndex"
                    class="form-control-label">{{ $t('views.userdata.form.streetNumber') }}:</label>
                  <input
                    :id="'user_data_street_number_'+addressIndex"
                    v-model="item.userDataAddresses[addressIndex].streetNumber"
                    class="form-control"
                    type="text">
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="form-group">
                  <label
                    :for="'userdata_street_'+addressIndex"
                    class="form-control-label">{{ $t('views.userdata.form.placeNumber') }}:</label>
                  <input
                    :id="'user_data_local_number_'+addressIndex"
                    v-model="item.userDataAddresses[addressIndex].placeNumber"
                    class="form-control"
                    type="text">
                </div>
              </b-col>
              <b-col sm="12" lg="5">
                <div class="form-group">
                  <label
                    :for="'userdata_city_'+addressIndex"
                    class="form-control-label">{{ $t('views.firm.form.city') }}:</label>
                  <input
                    :id="'userdata_city_'+addressIndex"
                    v-model="item.userDataAddresses[addressIndex].city"
                    class="form-control"
                    type="text">
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="form-group">
                  <label
                    :for="'userdata_postcode_'+addressIndex"
                    class="form-control-label">{{ $t('views.firm.form.postcode') }}:</label>
                  <input
                    :id="'userdata_postcode_'+addressIndex"
                    v-model="item.userDataAddresses[addressIndex].postcode"
                    class="form-control"
                    type="text">
                </div>
              </b-col>
              <b-col sm="12" lg="4">
                <div class="form-group">
                  <label
                    :for="'userdata_province_'+addressIndex"
                    class="form-control-label">{{ $t('views.firm.form.province') }}:</label>
                  <model-select :options="provinceOptions" v-model="item.userDataAddresses[addressIndex].province"></model-select>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="align-self-center">
            <button
              type="button"
              class="btn btn-link fa fa-trash fa-lg"
              @click="removeAddress(addressIndex)"
              v-b-tooltip :title="$t('views.userdata.form.deleteAddress')">
            </button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button
          type="button"
          class="btn btn-sm"
          @click="addNewAddress()">
          {{ $t('views.userdata.form.addNewAddress') }}
        </button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="userdata_country"
            class="form-control-label">{{ $t('views.firm.form.country') }}:</label>
          <input
            id="userdata_country"
            v-model="item.country"
            :class="['form-control', isInvalid('country') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('country', $event.target.value)">
          <div
            v-if="isInvalid('country')"
            class="invalid-feedback">{{ violations.country }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4" v-if="!isWholesaler && !isSalesRepresentative">
        <div class="form-group">
          <label
            for="userdata_supplier"
            class="form-control-label">{{ $t('views.firm.form.supplier') }}:</label>
          <el-select
            class="select-default"
            v-model="item.supplier"
            :placeholder="$t('views.firm.form.supplier')">
            <el-option
              class="select-default"
              v-for="item in yesNoOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
          <div
            v-if="isInvalid('supplier')"
            class="invalid-feedback">{{ violations.supplier }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4" v-if="!isWholesaler && !isSalesRepresentative">
        <div class="form-group">
          <label
            for="userdata_recipient"
            class="form-control-label">{{ $t('views.firm.form.recipient') }}:</label>
          <el-select
            class="select-default"
            v-model="item.recipient"
            :placeholder="$t('views.firm.form.recipient')">
            <el-option
              class="select-default"
              v-for="item in yesNoOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
          <div
            v-if="isInvalid('recipient')"
            class="invalid-feedback">{{ violations.recipient }}</div>
        </div>
      </b-col>
      <b-col cols="12" v-if="!isWholesaler">
        <div class="form-group">
          <label
                  for="userdata_extraInfo"
                  class="form-control-label">{{ $t('views.firm.form.extraInfo') }}:</label>
          <input
                  id="userdata_extraInfo"
                  v-model="item.extraInfo"
                  :class="['form-control', isInvalid('extraInfo') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('extraInfo', $event.target.value)">
          <div
                  v-if="isInvalid('extraInfo')"
                  class="invalid-feedback">{{ violations.extraInfo }}</div>
        </div>
      </b-col>
      <b-col cols="2" lg="2">
        <label
          for="is_company"
          class="form-control-label">{{$t('views.firm.form.doNotVindicate')}}:</label>
        <b-form-group>
          <b-form-radio-group buttons id="do_not_vindidicate" button-variant="outline-primary" v-model="item.doNotVindicate" name="doNotVindicate">
            <b-form-radio size="sm" :value="0" variant="success" class="mt-0">{{$t('buttons.no')}}</b-form-radio>
            <b-form-radio size="sm" :value="1" variant="info" class="mt-0">{{$t('buttons.yes')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-collapse id="collapse" v-model="isCompanyBool">
      <b-row v-if="routeName === 'FirmCreate' && employeesOptions.length > 0 && isCompanyBool">
        <b-col>
          <b-row v-if="item.userDataEmployees.length > 0">
            <b-col>
              <h5>{{ $t('views.firm.form.employees') }}:</h5>
            </b-col>
          </b-row>
          <b-row v-for="(userDataEmployee, index) in item.userDataEmployees" :index="index" v-bind:key="'userDataEmployee-' + index">
            <b-col cols="12" lg="1">
              <h5 class="pt-1 text-center">#{{ index + 1 }}</h5>
            </b-col>
            <b-col cols="12" lg="5">
              <div class="form-group">
                <fg-input>
                  <el-select
                          class="select-default"
                          filterable
                          v-model="item.userDataEmployees[index].employee">
                    <el-option v-for="option in employeesOptions"
                               class="select-default"
                               :value="option['@id']"
                               :label="option.name + ' ' + option.surname"
                               :key="option['@id']">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>
            </b-col>
            <b-col cols="12" lg="5">
              <div class="form-group">
                <fg-input>
                  <el-select
                          class="select-default"
                          filterable
                          v-model="item.userDataEmployees[index].isContactPerson">
                    <el-option v-for="option in contactOptions"
                               class="select-default"
                               :value="option.value"
                               :label="option.text"
                               :key="option.value">
                    </el-option>
                  </el-select>
                </fg-input>
              </div>
            </b-col>
            <b-col cols="12" lg="1">
              <b-btn class="btn btn-danger mt-0 float-right" @click="removeEmployee(index)">{{ $t('buttons.delete') }}</b-btn>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-btn class="btn btn-primary btn-sm" @click="addEmployee()">{{ $t('views.firm.form.addNewEmployee') }}</b-btn>
              <b-btn v-if="item.userDataEmployees.length > 0" class="btn btn-primary btn-sm" @click="addUserData()">{{ $t('views.firm.form.addNewPerson') }}</b-btn>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-collapse>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
    <CreateUserDataModal></CreateUserDataModal>
  </form>
</template>

<script>
import CreateUserDataModal from '../userdata/component/CreateUserDataModal'
import ApiService from '@/utils/ApiService'
import { MultiSelect, ModelSelect } from 'vue-search-select'
import { mapGetters } from 'vuex'
import { getUserRoles } from '@/utils/checkRoles'
import { ENTRYPOINT } from '@/config/entrypoint'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'

export default {
  components: {
    BaseSelectInput,
    CreateUserDataModal,
    MultiSelect,
    ModelSelect
  },

  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      addresses: [],
      statusOptions: [],
      salesOpportunitiesOptions: [],
      workplacesOptions: [],
      regionsOptions: [],
      headquartersOptions: [],
      employeesOptions: [],
      tagsOptions: [],
      routeName: '',
      firmType: 0,
      firmClientTypes: [
        {
          value: this.pathForm() + 'client_types/7',
          text: this.$t('roles.roleClient')
        },
        {
          value: this.pathForm() + 'client_types/6',
          text: this.$t('roles.roleFirm')
        },
        {
          value: this.pathForm() + 'client_types/13',
          text: this.$t('roles.roleWholesaler')
        }
      ],
      firmTypes: [
        {
          value: 0,
          text: this.$t('views.firm.form.types.department')
        },
        {
          value: 1,
          text: this.$t('views.firm.form.types.headquarters')
        }
      ],
      lastSelectItem: {},
      items: [],
      contactOptions: [
        {
          value: 0,
          text: this.$t('views.firm.form.contact.isNotContactPerson')
        },
        {
          value: 1,
          text: this.$t('views.firm.form.contact.isContactPerson')
        }
      ],
      yesNoOptions: [
        {
          value: 0,
          text: this.$t('buttons.no')
        },
        {
          value: 1,
          text: this.$t('buttons.yes')
        }
      ],
      provinceOptions: [
        { value: 'dolnośląskie', text: 'dolnośląskie' },
        { value: 'kujawsko-pomorskie', text: 'kujawsko-pomorskie' },
        { value: 'lubelskie', text: 'lubelskie' },
        { value: 'lubuskie', text: 'lubuskie' },
        { value: 'łódzkie', text: 'łódzkie' },
        { value: 'małopolskie', text: 'małopolskie' },
        { value: 'mazowieckie', text: 'mazowieckie' },
        { value: 'opolskie', text: 'opolskie' },
        { value: 'podkarpackie', text: 'podkarpackie' },
        { value: 'podlaskie', text: 'podlaskie' },
        { value: 'pomorskie', text: 'pomorskie' },
        { value: 'śląskie', text: 'śląskie' },
        { value: 'świętokrzyskie', text: 'świętokrzyskie' },
        { value: 'warmińsko-mazurskie', text: 'warmińsko-mazurskie' },
        { value: 'wielkopolskie', text: 'wielkopolskie' },
        { value: 'zachodniopomorskie', text: 'zachodniopomorskie' }
      ],
      isExpanded: null
    }
  },

  computed: {
    ...mapGetters({
      addressTypeOptions: 'userdataaddress/list/addressTypeOptions'
    }),
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    isSalesRepresentative () {
      return getUserRoles().roles.includes('ROLE_SALES_REPRESENTATIVE')
    },
    isCompanyBool: {
      get () {
        return Boolean(this.item.isCompany)
      },
      set (val) {
        this.isExpanded = val
      }
    },
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },

    employeesListUpdated: function () {
      return this.$store.state.modals.userdata.create.created
    }
  },

  watch: {
    'isCompanyBool' (val) {
      if (val === false) {
        this.item.userDataEmployees = []
      }
    },
    employeesListUpdated: function (val) {
      if (val === 1) {
        this.$store.state.modals.userdata.create.created = 0
        this.getEmployees()
      }
    }
  },

  created () {
    this.routeName = this.$route.name
    this.getEmployees()
    this.getHeadquarters()
    this.getStatuses()
    this.getSalesOportunities()
    this.getWorkplaces()
    this.getTags()
    this.getRegions()
  },
  methods: {
    pathForm () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    },
    addNewAddress () {
      this.item.userDataAddresses.push({
        addressType: this.$store.getters['configuration/defaultAddressType'],
        street: '',
        streetNumber: '',
        placeNumber: '',
        postcode: '',
        province: ''
      })
    },
    removeAddress (addressIndex) {
      this.item.userDataAddresses.splice(addressIndex, 1)
    },
    addUserData () {
      this.$store.state.modals.userdata.create.show = 1
    },

    removeEmployee (index) {
      this.item.userDataEmployees.splice(index, 1)
    },

    addEmployee () {
      let item = {
        employee: null,
        isContactPerson: 0,
        vatInvoiceRecipient: 0
      }
      this.item.userDataEmployees.push(item)
    },
    async getHeadquarters () {
      let params = {
        'pagination': false,
        'isCompany': 1,
        'isHeadquarters': 1,
        'state': 1
      }

      const response = await new ApiService('user_datas', params).getResults()
      this.headquartersOptions = response.items
    },
    async getEmployees () {
      let params = {
        'pagination': false,
        'idClientType': 7
      }

      const response = await new ApiService('user_datas', params).getResults()
      this.employeesOptions = response.items
    },
    async getSalesOportunities () {
      let params = { pagination: false, state: 1 }
      this.salesOpportunitiesOptions = [{ text: this.$t('global.notSet'), value: null }]
      const response = await new ApiService('e_x_c_m_user_data_sales_opportunities', params).getResults()
      response.items.forEach(entry => {
        this.salesOpportunitiesOptions.push({ text: entry.title, value: entry['@id'] })
      })
    },
    async getWorkplaces () {
      let params = { 'pagination': false }
      this.workplacesOptions = [{ text: this.$t('global.notSet'), value: null }]
      const response = await new ApiService('e_x_c_m_user_data_workplaces', params).getResults()
      response.items.forEach(entry => {
        this.workplacesOptions.push({ text: entry.title, value: entry['@id'] })
      })
    },
    async getTags () {
      let params = { 'pagination': false, tagType: 2 }
      const response = await new ApiService('e_x_c_m_tags', params).getResults()
      response.items.forEach(entry => {
        this.tagsOptions.push({ text: entry.tag, value: entry['@id'] })
      })
    },
    async getRegions () {
      let params = {
        'pagination': false
      }
      this.regionsOptions = [
        {
          title: this.$t('global.notSet'),
          value: null
        }
      ]
      const response = await new ApiService('e_x_c_m_regions', params).getResults()
      response.items.forEach(entry => {
        this.regionsOptions.push(entry)
      })
    },
    async getStatuses () {
      let params = {
        pagination: false,
        state: 1
      }
      this.statusOptions = [{ text: this.$t('global.notSet'), value: null }]
      const response = await new ApiService('e_x_c_m_user_data_statuses', params).getResults()
      response.items.forEach(entry => {
        this.statusOptions.push({ text: entry.title, value: entry['@id'] })
      })
    },
    getFirmDataByNip (nip) {
      this.$http.get('api/e_x_s_b_gus?nip=' + nip)
        .then(response => {
          let data = response.data['hydra:member'][0].data
          this.item.firmname1 = data.firmname
          this.item.firmname2 = data.firmname
          this.item.street = data.street
          this.item.streetNumber = data.streetNumber
          this.item.placeNumber = data.placeNumber
          this.item.city = data.city
          this.item.postcode = data.postcode
          this.item.province = data.province ? data.province.toLowerCase() : ''
          this.item.regon = data.regon ? data.regon : null
          this.item.krs = data.krs ? data.krs : null
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    async getSalesRepresentativesCallback (params = {}) {
      let baseParams = { pagination: false, idClientType: 4 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    onSelectTags (items, lastSelectItem) {
      this.item.userDataTags = items
      this.lastSelectTag = lastSelectItem
    }
  }
}
</script>
